<template>
  <div>
    <div class="all-content">
      <div class="location">
        <i class="el-icon-location-outline"></i>
        <div class="now-location">当前位置：</div>
        <el-breadcrumb separator-class="el-icon-arrow-right" class="break">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>{{ firstTitle }}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <el-radio-group
        v-model="tabPosition"
        style="margin-bottom: 30px"
      ></el-radio-group>
      <div class="all-content">
        <div class="choose">
          <div :class="['choose-item',tabactive==25?'active':'']" @click="chooseOne(25, '政协全体会议')">
            政协全体会议
          </div>
          <div :class="['choose-item',tabactive==26?'active':'']" @click="chooseOne(26, '政协常委会议')">
            政协常委会议
          </div>
          <div :class="['choose-item',tabactive==27?'active':'']" @click="chooseOne(27, '政协主席会议')">
            政协主席会议
          </div>
        </div>
        <div class="contentw one" ref="content" v-show="classifyId == 25">
          <first-component :classifyId="25"></first-component>
        </div>
        <div class="contentw two" ref="content" v-show="classifyId == 26">
          <first-component :classifyId="26"></first-component>
        </div>
        <div class="contentw" ref="content" v-show="classifyId == 27">
          <first-component :classifyId="27"></first-component>
        </div>
        <div class="content-one" ref="contentOne">
          <div class="content-right"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import lib from '../api/index';
import FirstComponent from '../components/FirstComponent.vue';
export default {
  components: { FirstComponent },
  data() {
    return {
      defaultImg:
        'this.src="' + require('../../static/image/home/img1.jpg') + '"',
      tabPosition: 'left',
      firstTitle: '政协全体会议',
      tablist: [
        {
          name: '政协全体会议',
          id: 25,
        },
        {
          name: '政协常委会议',
          id: 26,
        },
        {
          name: '政协主席会议',
          id: 27,
        },
      ],
      list: [],
      searchForm: {
        page: 1,
        size: 10,
      },
      page: 1,
      total: 0,
      classifyId: 25,
    };
  },
computed:{
  tabactive(){
    return this.$route.query.classifyId
  }
},
  mounted() {
    if (this.$route.query.name && this.$route.query.classifyId) {
      this.chooseOne(this.$route.query.classifyId, this.$route.query.name);
    } else {
      this.chooseOne(25, '政协全体会议');
    }
  },
  methods: {
    goDetails1(item, names) {
      if (item.link == null || item.link == '') {
        this.$router
          .push({
            path: '/pageDetails',
            query: {
              id: item.id,
              name: names,
            },
          })
          .catch((r) => r);
      } else {
        location.href = item.link;
      }
    },
    displayShow() {},
    getData() {
      this.searchForm.page = this.page;
      lib
        .appInformationList({
          params: this.searchForm,
        })
        .then((res) => {
          this.total = res.data.total;
          this.list = res.data.records;
          for (let i = 0; i < this.list.length; i++) {
            // console.log(this.list[i].content)
            if (this.list[i].content !== '' && this.list[i].content !== null) {
              this.list[i].content = this.list[i].content
                .replace(/<\/?(img)[^>]*>/gi, '')
                .replace(/<(p|div)[^>]*>(<br\/?>|&nbsp;)<\/\1>/gi, '\n')
                .replace(/<br\/?>/gi, '\n')
                .replace(/<[^>/]+>/g, '')
                .replace(/(\n)?<\/([^>]+)>/g, '')
                .replace(/\u00a0/g, ' ')
                .replace(/&nbsp;/g, ' ')
                .replace(/<\/?(img)[^>]*>/gi, '')
                .replace(/&amp;/g, '&')
                .replace(/&lt;/g, '<')
                .replace(/&gt;/g, '>')
                .replace(/&#39;/g, "'")
                .replace(/&quot;/g, '"')
                .replace(/<\/?.+?>/g, '');
            }
          }
        });
    },
    chooseOne(classifyId, title) {
      this.classifyId = classifyId;
      if (classifyId != this.$route.query.name) {
        this.page = 1;
        this.$router.push({
          push: '/zxhy',
          query: { name: title, classifyId: classifyId },
        });
      }
      this.searchForm.classifyId = classifyId;
      this.firstTitle = title;

      this.getData();
    },
  },
};
</script>
<style scoped>
.contentw >>> .all-content {
  width: 876px;
  margin: unset;
  float: right;
}
.time {
  background: url(../../static/img/list10.jpg) no-repeat 0 center;
}
.view {
  background: url(../../static/img/list11.jpg) no-repeat 0 center;
}
.foot2 span {
  /* float: left; */
  font-size: 14px;
  color: #c5c5c5;
  margin-right: 25px;
  padding-left: 17px;
}
.foot-one p {
  width: 100%;
  overflow: hidden;
  font-size: 16px;
  color: #888888;
  line-height: 20px;
  margin-top: 0px;
  max-height: 41px;
}
.foot2 {
  padding: 16px 0;
  border-bottom: 1px solid #f0f0f0;
  cursor: pointer;
  margin-top: 10px;
  width: 100%;
  overflow: hidden;
}
.foot-right:hover h3 {
  color: red;
}
.foot-one:hover h3 {
  color: red;
}
.all-foot-imfg {
  width: 220px;
  margin-right: 20px;
  overflow: hidden;
  display: inline-block;
  float: left;
}
.foot-img {
  width: 220px;

  vertical-align: top;
  display: inline-block;
}
.foot-img:hover {
  transition: transform 2s ease 0s;
  transform: scale(1.4);
}
.foot-right {
  /* display: inline-block; */
  width: 490px;
  /* height: 200px; */
  float: left;
  /* margin-top: 50px; */
}
.foot-one {
  width: 1100px;
  /* height: 116px; */
  /* margin-top: -50px; */
}
.foot-right h3 {
  font-size: 20px;
}
.foot-right p {
  /* float: left; */
  width: 100%;
  font-size: 16px;
  color: #888888;
  line-height: 20px;
  margin-top: 0px;
  /* 超出三行用省略号显示 */
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  overflow: hidden;
}
.foot-right span {
  /* float: left; */
  font-size: 14px;
  color: #c5c5c5;
  margin-right: 25px;
  padding-left: 17px;
}
.all-content {
  width: 1100px;
  margin: 0 auto;
  overflow: hidden;
  font-size: 15px;
}
.location {
  background-color: rgb(243, 243, 243);
  background-image: url(../assets/img/bg.jpg);
  padding-top: 10px;
  padding-bottom: 10px;
}
.break {
  display: inline-block;
}
.el-icon-location-outline {
  margin-left: 10px;
}
.now-location {
  display: inline-block;
  font-size: 13px;
  position: relative;
  top: -2px;
}
.choose {
  /* margin-left: -40px; */
}
.choose-item {
  /* width: 90px; */
  line-height: 42px;
  padding: 0 46px;
  margin-bottom: 20px;
  background: #F5F5F5;
  text-align: center;
  display: inline-block;
  cursor: pointer;
  border-bottom: 1px solid transparent;
}

.choose-item:hover {
  color: #015293;
  background-color: #D4E5F5;
}
.choose-item.active{

  color: #015293;
  background-color: #D4E5F5;
}

.choose {
  width: 220px;
  min-height: 580px;
  float: left;
  font-size: 16px;
  /* display: inline-block; */
}
.choose-one {
  width: 220px;
  min-height: 580px;
  float: left;
  font-size: 16px;
  display: none;
}
.choose ul li {
  list-style: none;
}
.content {
  float: right;
  width: 800px;
  height: 700px;
  padding: 0 20px;
  overflow: scroll;
  margin-bottom: 2px;
  border: 1px solid #ccc;
  margin-bottom: 40px;
  /* display: inline-block; */
}
.content-one {
  float: right;
  width: 800px;
  border: 1px solid #ccc;
  padding: 0 20px;
  display: none;
}
.content-right {
  float: left;
  width: 100%;
  /* background-color: darkcyan; */
  overflow: hidden;
  padding: 20px 0;
  line-height: 2em;
  color: #000000;
  font-size: 18px;
}
.content-right-one {
  /* height: 600px; */
  margin: 0 auto;
  font-weight: bolder;
  text-align: center;
}
.foot {
  width: 1100px;
  margin: 0 auto;
  background-color: #1d71b7;
  padding-top: 30px;
  padding-bottom: 30px;
}
</style>



// WEBPACK FOOTER //
// src/pages/zxhy.vue